import Router from 'vue-router'
import AuthenticationService from '@/services/authentication'

import AuthCallback from '@/views/AuthCallback.vue'

const Start = () => import(/* webpackChunkName: "start" */ '@/views/Start.vue')
const Deployments = () => import(/* webpackChunkName: "topology" */ '@/views/Deployments.vue')
const Deployment = () => import(/* webpackChunkName: "topology" */ '@/views/Deployment.vue')
const GeoMap = () => import(/* webpackChunkName: "geomap" */ '@/views/GeoMap.vue')
const Integrations = () => import(/* webpackChunkName: "integrations" */ '@/views/Integrations.vue')

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH || '/',
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: AuthCallback
    },
    {
      path: '/start',
      name: 'Start',
      component: Start
    },
    {
      path: '/deployment/:id',
      name: 'Deployment',
      component: Deployment,
    },
    {
      path: '/deployments',
      name: 'Deployments',
      component: Deployments,
    },
    {
      path: '/geomap',
      name: 'GeoMap',
      component: GeoMap
    },
    {
      path: '/integrations',
      name: 'Integrations',
      component: Integrations
    },
    {
      path: '/',
      redirect: '/start'
    },
    {
      path: '*',
      redirect: '/start'
    }
  ]
})

router.beforeEach((to, _, next) => {
  if (to.path === '/callback' || AuthenticationService.isAuthenticated()) {
    return next()
  }

  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  AuthenticationService.login(JSON.stringify({
    base: process.env.VUE_APP_BASE_PATH || '/',
    path: to.path
  }))
})

export default router
